import { styled } from "@mui/material/styles";
import { Grid, Link } from "@mui/material";

export const LinkList = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  marginLeft: 11,
});

const menuItemStyles = (theme) => ({
  margin: "16px 0",
  display: "block",
  "&#ecards, & #button-invitations, &#ai-image-packs": {
    color: theme.palette.primary.main,
  },
});

export const ExternalStyledMenuItem = styled(Link)(({ theme }) => menuItemStyles(theme));

export const InternalStyledMenuItem = styled(Link)(({ theme }) => ({
  ...menuItemStyles(theme),
  "&.active": {
    "&::after": {
      content: "''",
      display: "block",
      background: theme.palette.primary.main,
      width: "4px",
      height: "24px",
      position: "absolute",
      marginTop: "-24px",
      marginLeft: "-10px",
    },
  },
}));

export const CollapsableMenuItem = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "hasActiveSubLink",
})(({ theme, hasActiveSubLink }) => ({
  ...menuItemStyles(theme),
  ...(hasActiveSubLink && {
    "&::after": {
      content: "''",
      display: "block",
      background: theme.palette.primary.main,
      width: "4px",
      height: "24px",
      position: "absolute",
      marginTop: "-24px",
      marginLeft: "-10px",
    },
  }),
}));

export const LinkInList = styled(Link)({
  margin: "13px 0",
});
